import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface DeleteResponse {
  message: string;
  nbContacts: number;
  nbJobs: number;
  nbSms: number;
}

async function deleteContactsNotAddressed(
  apiKey: string,
  auth: Authentication
): Promise<{data: DeleteResponse} | undefined> {
  try {
    return await HttpClient.delete(
      '/contacts/notaddressed/all',
      {},
      auth.token,
      {
        'x-api-key': apiKey,
      }
    );
  } catch (e) {
    console.log('error: ', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new DeleteContactsNotAddressedFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new DeleteContactsNotAddressedFailure(e.message);
    }
  }
}

export class DeleteContactsNotAddressedFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteContactsNotAddressed;
